import axios from "axios";

import StringUtil from "../../../src/app/StringUtil";
import ReferenceData from "../constants/ReferenceData";

export interface ContactDetails {
    contactInfoUpdateRequired: boolean;
    countryDetails: CountryDetail[];
    domesticCntryCode: string;
    domesticMobile: string;
    home: string;
    intCntryCode?: string;
    intlNumber?: string;
    personalEmailAddress: string;
    phoneNumber: string;
}

export interface CountryDetail {
    countryCode: string;
    countryName: string;
    countryPhAndCd: string;
    countryPhNo?: string;
}

const retrieveContactDetails = async () => {
    const url = StringUtil.supplant(ReferenceData.RETRIEVE_CONTACT_DETAIL);
    const response = await axios.get<ContactDetails>(url);

    return response.data;
};

export default retrieveContactDetails;
